import React, { Component } from "react";
import {
  HashRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import MainPage from "./js/packs/routes/mainPage/MainPage";
import DownloadPage from "./js/packs/routes/downloadPage/DownloadPage";
import ManageUsersPage from "./js/packs/routes/manageUsersPage/ManageUsersPage";
import RequestsPage from "./js/packs/routes/requestsPage/RequestsPage";
import LoginPage from "./js/packs/routes/loginPage/LoginPage";
import LoginPopup from "./js/packs/components/login/LoginPopup";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

class App extends Component {

  state = {
    showLoginPopup:false,
    failedRequestInfo: []
  };

  componentDidMount() {
    window.addEventListener("unauthorized",(e) => {
      const newFailedRequest = [...this.state.failedRequestInfo, e.detail.failedRequestInfo];
      this.setState({
        showLoginPopup: true,
        failedRequestInfo: newFailedRequest
      })
    });
  }

  render() {
    const { showLoginPopup, failedRequestInfo } = this.state;
    return (
      <>
        <HashRouter>
          <Routes>
            <Route path={'/main'} element={<MainPage />} />
            <Route path={'/users'} element={<ManageUsersPage />} />
            <Route path={'/requests'} element={<RequestsPage />} />
            <Route path={'/download'} element={<DownloadPage />} />
            <Route path={'/login'} element={<LoginPage />} />
            <Route path="/" element={<Navigate to={'/login'} />} />
          </Routes>
        </HashRouter>
        <LoginPopup showPopup={!!showLoginPopup} closePopup={()=>{
          this.setState({
            showLoginPopup: false
          })
        }} failedRequestInfo={failedRequestInfo} />
      </>
    );
  }
}

export default App;
